import { DetailedHTMLProps, HTMLAttributes, ReactNode } from "react";
import { TextProps as AntDTextProps } from "antd/es/typography/Text";
import { EnigmaTokens } from "@type/tokens";

export const TITLE_LEVELS = [1, 2, 3, 4, 5, 6] as const;
type TitleLevelsType = (typeof TITLE_LEVELS)[number];
export const TEXT_LEVELS = [1, 2, 3] as const;
type TextLevelsType = (typeof TEXT_LEVELS)[number];
export const CODE_LEVELS = [1, 2] as const;
type CodeLevelsType = (typeof CODE_LEVELS)[number];

export enum FontWeights {
    regular = 400,
    medium = 500,
    bold = 700,
}

export enum FontWeightsMap {
    REGULAR = "regular",
    MEDIUM = "medium",
    BOLD = "bold",
}

type WeightsType = keyof typeof FontWeights;

export enum TypographyTypes {
    secondary = "secondary",
    warning = "warning",
    success = "success",
    danger = "danger",
    default = "default",
}

export interface TitleProps
    extends DetailedHTMLProps<
        HTMLAttributes<HTMLHeadingElement>,
        HTMLHeadingElement
    > {
    level?: TitleLevelsType;
    strong?: boolean;
    type?: keyof typeof TypographyTypes;
    mark?: boolean;
    underline?: boolean;
    italic?: boolean;
    strikethrough?: boolean;
    disabled?: boolean;
    children: ReactNode;
}

export type StyledTitleProps = Omit<TitleProps, "children"> & {
    token: EnigmaTokens;
};

export interface TextProps extends AntDTextProps {
    level?: TextLevelsType;
}

export type StyledTextProps = TextProps & {
    token: EnigmaTokens;
};

export interface FootnoteProps
    extends DetailedHTMLProps<
        HTMLAttributes<HTMLParagraphElement>,
        HTMLParagraphElement
    > {
    strong?: boolean;
    children: ReactNode;
}

export interface CodeProps
    extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
    weight?: WeightsType;
    level?: CodeLevelsType;
    children: ReactNode;
}

export type StyledCodeProps = Omit<CodeProps, "children"> & {
    token: EnigmaTokens;
};
